import React from 'react';
import { Skeleton } from '../components/ui/skeleton';

export const CardSkeleton = ({ count = 3 }) => (
  <div className={`grid grid-cols-2 sm:grid-cols-${count} gap-3`}>
    {Array.from({ length: count }).map((_, i) => (
      <div key={i} className="bg-card border border-border rounded-sm p-4 sm:p-6 space-y-3">
        <Skeleton className="h-3 w-20" />
        <Skeleton className="h-8 w-32" />
        <Skeleton className="h-2 w-16" />
      </div>
    ))}
  </div>
);

export const ChartSkeleton = () => (
  <div className="bg-card border border-border rounded-sm p-5 space-y-4">
    <div className="flex items-center gap-3">
      <Skeleton className="h-5 w-5 rounded" />
      <div className="space-y-1">
        <Skeleton className="h-4 w-36" />
        <Skeleton className="h-2.5 w-24" />
      </div>
    </div>
    <div className="flex items-end gap-2 h-48">
      {Array.from({ length: 12 }).map((_, i) => (
        <Skeleton key={i} className="flex-1 rounded-t-sm" style={{ height: `${30 + Math.random() * 70}%` }} />
      ))}
    </div>
  </div>
);

export const TableSkeleton = ({ rows = 5 }) => (
  <div className="bg-card border border-border rounded-sm p-5 space-y-4">
    <Skeleton className="h-5 w-40" />
    <div className="space-y-3">
      {Array.from({ length: rows }).map((_, i) => (
        <div key={i} className="flex items-center gap-4">
          <Skeleton className="h-4 w-16" />
          <Skeleton className="h-4 flex-1" />
          <Skeleton className="h-4 w-24" />
          <Skeleton className="h-4 w-20" />
        </div>
      ))}
    </div>
  </div>
);

export const TabsSkeleton = () => (
  <div className="flex items-center gap-1 mb-4">
    {Array.from({ length: 6 }).map((_, i) => (
      <Skeleton key={i} className="h-9 w-20 rounded-sm" />
    ))}
  </div>
);

export const MasterSkeleton = () => (
  <div className="space-y-6" data-testid="master-skeleton">
    <CardSkeleton count={6} />
    <div className="flex gap-2">
      <Skeleton className="h-9 w-32 rounded-sm" />
      <Skeleton className="h-9 w-24 rounded-sm" />
      <Skeleton className="h-9 w-32 rounded-sm" />
    </div>
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
      <div className="bg-card border border-border rounded-sm p-5 flex flex-col items-center gap-4">
        <Skeleton className="h-3 w-32" />
        <Skeleton className="h-28 w-28 rounded-full" />
      </div>
      <ChartSkeleton />
      <ChartSkeleton />
    </div>
  </div>
);

export const PurchasesSkeleton = () => (
  <div className="space-y-6" data-testid="purchases-skeleton">
    <TabsSkeleton />
    <CardSkeleton count={3} />
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
      <ChartSkeleton />
      <div className="bg-card border border-border rounded-sm p-5 space-y-4">
        <Skeleton className="h-4 w-28" />
        {Array.from({ length: 5 }).map((_, i) => (
          <div key={i} className="flex items-center gap-3">
            <Skeleton className="h-3 w-4" />
            <Skeleton className="h-3 flex-1" />
            <Skeleton className="h-3 w-20" />
          </div>
        ))}
      </div>
    </div>
    <TableSkeleton rows={5} />
  </div>
);

export const ExpensesSkeleton = () => (
  <div className="space-y-6" data-testid="expenses-skeleton">
    <TabsSkeleton />
    <CardSkeleton count={4} />
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
      <ChartSkeleton />
      <ChartSkeleton />
    </div>
    <TableSkeleton rows={5} />
  </div>
);

export const SalesSkeleton = () => (
  <div className="space-y-6" data-testid="sales-skeleton">
    <CardSkeleton count={3} />
    <TabsSkeleton />
    <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
      <div className="lg:col-span-2"><ChartSkeleton /></div>
      <div className="bg-card border border-border rounded-sm p-5 space-y-3">
        <Skeleton className="h-5 w-28" />
        {Array.from({ length: 4 }).map((_, i) => (
          <Skeleton key={i} className="h-10 w-full rounded-sm" />
        ))}
      </div>
    </div>
    <TableSkeleton rows={6} />
  </div>
);
